/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_SubInputs */

const en_pb_sub = /** @type {(inputs: Pb_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A playbook is a ready idea, three things you can ask for, and the rules the builder must follow. Pick one, and the plan starts filled in.`)
};

const id_pb_sub = /** @type {(inputs: Pb_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playbook adalah ide yang sudah jadi, tiga hal yang bisa Anda minta, dan aturan yang wajib diikuti pembangun. Pilih satu, rencana langsung terisi.`)
};

/**
* | output |
* | --- |
* | "A playbook is a ready idea, three things you can ask for, and the rules the builder must follow. Pick one, and the plan starts filled in." |
*
* @param {Pb_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_sub = /** @type {((inputs?: Pb_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_sub(inputs)
	return en_pb_sub(inputs)
});